var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".right-arrow{fill:none;stroke:#a6a7a8;stroke-width:2px;}")),React.createElement("g",{"id":"ea66953b-2366-4137-b3c9-cf74c5b146e4","data-name":"Group 24","key":1},[React.createElement("path",{"id":"a7e09a2f-9778-43f6-b64c-48f77f1949b1","data-name":"Path 218","className":"right-arrow","d":"M0,6.03322H70.246","key":0}),React.createElement("path",{"id":"ee0f6abe-0ee1-4386-82d3-4e2bec66acd6","data-name":"Path 219","className":"right-arrow","d":"M65.027.70717l5.439,5.438-5.439,5.438","key":1})])]);
}

RightArrow.defaultProps = {"id":"e53de142-1d26-4588-ad7c-b0654208956a","data-name":"Layer 1","viewBox":"0 0 71.88028 12.29032"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
